export const parseSub = (raw?: string) => {
  if (!raw) return undefined;
  const parts = raw.split(" - ").map((s) => s.trim());
  // e.g. ["68'", "Substitution", "Asencio", "Ceballos", "(Team)"]
  const idxType = parts.findIndex((p) => p.toLowerCase() === "substitution");
  if (idxType >= 0 && parts[idxType + 1] && parts[idxType + 2]) {
    return { inPlayer: parts[idxType + 1], outPlayer: parts[idxType + 2] };
  }
  return undefined;
};

export const parseReason = (raw?: string) => {
  if (!raw) return undefined;
  const m = raw.match(/(Yellow Card|Red Card)\s*-\s*(.+)$/i);
  if (m && m[2]) return m[2].replace(/\(.+?\)$/g, "").trim();
  return undefined;
};

export const parseAssist = (raw?: string) => {
  if (!raw) return undefined;
  const txt = raw.replace(/\s+/g, " ").trim();

  // (Assist: Schouten)
  let m = txt.match(/\(\s*Assist\s*(?:-|:)\s*([^)]+)\)/i);
  if (m?.[1]) return m[1].trim();

  // Assist by Schouten
  m = txt.match(/Assist\s+by\s+([A-Za-zÀ-ž'.\s-]+)/i);
  if (m?.[1]) return m[1].replace(/[-–—]\s*$/, "").trim();

  // Assist: Schouten  |  Assist - Schouten
  m = txt.match(/Assist\s*(?:-|:)\s*([A-Za-zÀ-ž'.\s-]+)/i);
  if (m?.[1]) return m[1].trim();

  return undefined;
};

export const extractTeam = (raw?: string) => raw?.match(/\(([^)]+)\)/)?.[1];
